const statActionType = {
  // shop stats
  FETCH_SHOP_STATS: "FETCH_SHOP_STATS",
  FETCH_SHOP_STATS_SUCCESS: "FETCH_SHOP_STATS_SUCCESS",
  FETCH_SHOP_STATS_FAILURE: "FETCH_SHOP_STATS_FAILURE",
  // shop stats
  FETCH_TOTAL_STATS: "FETCH_TOTAL_STATS",
  FETCH_TOTAL_STATS_SUCCESS: "FETCH_TOTAL_STATS_SUCCESS",
  FETCH_TOTAL_STATS_FAILURE: "FETCH_TOTAL_STATS_FAILURE",
};

export default statActionType;
